"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGlobalSearchStateToSearchControlCriteriaInput = exports.mapFormStateToGlobalSearchState = exports.mapGlobalSearchStateToFormState = exports.mapTravelRoomsFormStateToTravelRoomsGlobalState = exports.mapTravelDatesFormStateToTravelDatesGlobalState = exports.mapTravelRoomsGlobalStateToTravelRoomsFormState = exports.mapTravelDatesGlobalStateToTravelDatesFormState = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const components_common_travel_dates_1 = require("@hotelplan/components.common.travel-dates");
const components_common_travel_rooms_1 = require("@hotelplan/components.common.travel-rooms");
const libs_utils_1 = require("@hotelplan/libs.utils");
const GSS_constants_1 = require("./GSS.constants");
function mapTravelDatesGlobalStateToTravelDatesFormState(travelDates) {
    const returnDate = (0, libs_utils_1.parseDateStr)(travelDates.rd);
    const departureDate = (0, libs_utils_1.parseDateStr)(travelDates.dd);
    return {
        returnDate,
        departureDate,
        duration: travelDates.d,
        searchType: travelDates.st,
        extraDurations: travelDates.ed,
    };
}
exports.mapTravelDatesGlobalStateToTravelDatesFormState = mapTravelDatesGlobalStateToTravelDatesFormState;
function mapTravelRoomsGlobalStateToTravelRoomsFormState(travelRooms) {
    return {
        rooms: travelRooms.r,
        adults: travelRooms.a,
        childrenDobs: travelRooms.cd,
        travellersDistribution: travelRooms.td,
    };
}
exports.mapTravelRoomsGlobalStateToTravelRoomsFormState = mapTravelRoomsGlobalStateToTravelRoomsFormState;
function mapTravelDatesFormStateToTravelDatesGlobalState(travelDates) {
    const returnDate = (0, components_common_travel_dates_1.getReturnDate)(travelDates.departureDate, travelDates.returnDate, travelDates.duration) || '';
    const departureDate = travelDates
        ? (0, format_1.default)(travelDates.departureDate, GSS_constants_1.DATE_FORMAT)
        : '';
    return {
        rd: returnDate,
        dd: departureDate,
        d: travelDates.duration,
        st: travelDates.searchType,
        ed: travelDates.extraDurations,
    };
}
exports.mapTravelDatesFormStateToTravelDatesGlobalState = mapTravelDatesFormStateToTravelDatesGlobalState;
function mapTravelRoomsFormStateToTravelRoomsGlobalState(travelRooms) {
    return {
        r: travelRooms.rooms,
        a: travelRooms.adults,
        cd: travelRooms.childrenDobs,
        td: travelRooms.travellersDistribution,
    };
}
exports.mapTravelRoomsFormStateToTravelRoomsGlobalState = mapTravelRoomsFormStateToTravelRoomsGlobalState;
function mapGlobalSearchStateToFormState(globalSearchState) {
    const formState = {};
    if (!globalSearchState)
        return formState;
    if (globalSearchState.td) {
        const travelDates = mapTravelDatesGlobalStateToTravelDatesFormState(globalSearchState.td);
        formState.travelDates = (0, components_common_travel_dates_1.adjustTravelDates)(travelDates);
    }
    if (globalSearchState.tt) {
        formState.travelType = globalSearchState.tt;
    }
    if (globalSearchState.tr) {
        formState.travelRooms = mapTravelRoomsGlobalStateToTravelRoomsFormState(globalSearchState.tr);
    }
    return Object.assign({}, formState);
}
exports.mapGlobalSearchStateToFormState = mapGlobalSearchStateToFormState;
// direct conversion
function mapSearchControlToGSS(state) {
    const gss = {};
    if (!state)
        return gss;
    if (state.travelType) {
        gss.tt = state.travelType;
    }
    if (state.travelRooms) {
        gss.tr = mapTravelRoomsFormStateToTravelRoomsGlobalState(state.travelRooms);
    }
    if (state.travelDates) {
        gss.td = mapTravelDatesFormStateToTravelDatesGlobalState(state.travelDates);
    }
    return gss;
}
function mapFormStateToGlobalSearchState(defaultFormState, formState, currentState) {
    const resultGss = {};
    const defaultGss = mapSearchControlToGSS(defaultFormState);
    const nextGss = mapSearchControlToGSS(formState);
    const currentGss = mapSearchControlToGSS(currentState);
    if (nextGss.tt &&
        (!(0, fast_deep_equal_1.default)(defaultGss.tt, nextGss.tt) || (0, fast_deep_equal_1.default)(currentGss === null || currentGss === void 0 ? void 0 : currentGss.tt, nextGss.tt))) {
        resultGss.tt = nextGss.tt;
    }
    if (nextGss.tr &&
        (!(0, fast_deep_equal_1.default)(defaultGss.tr, nextGss.tr) || (0, fast_deep_equal_1.default)(currentGss === null || currentGss === void 0 ? void 0 : currentGss.tr, nextGss.tr))) {
        resultGss.tr = nextGss.tr;
    }
    if (nextGss.td &&
        (!(0, fast_deep_equal_1.default)(defaultGss.td, nextGss.td) || (0, fast_deep_equal_1.default)(currentGss === null || currentGss === void 0 ? void 0 : currentGss.td, nextGss.td))) {
        resultGss.td = nextGss.td;
    }
    return resultGss;
}
exports.mapFormStateToGlobalSearchState = mapFormStateToGlobalSearchState;
function mapGlobalSearchStateToSearchControlCriteriaInput(globalSearchState) {
    let criteriaInput = {};
    if (globalSearchState === null || globalSearchState === void 0 ? void 0 : globalSearchState.travelRooms) {
        criteriaInput = {
            rooms: (0, components_common_travel_rooms_1.mapFormTravelRoomsToSearchCriteriaInputRooms)(globalSearchState === null || globalSearchState === void 0 ? void 0 : globalSearchState.travelRooms),
            travellers: (0, components_common_travel_rooms_1.mapFormTravelRoomsToSearchCriteriaInputTravellers)(globalSearchState === null || globalSearchState === void 0 ? void 0 : globalSearchState.travelRooms),
        };
    }
    if (globalSearchState === null || globalSearchState === void 0 ? void 0 : globalSearchState.travelType) {
        criteriaInput = Object.assign(Object.assign({}, criteriaInput), { travelType: globalSearchState === null || globalSearchState === void 0 ? void 0 : globalSearchState.travelType });
    }
    if (globalSearchState === null || globalSearchState === void 0 ? void 0 : globalSearchState.travelDates) {
        criteriaInput = Object.assign(Object.assign({}, criteriaInput), { travelPeriod: (0, components_common_travel_dates_1.mapTravelDatesModelToTravelPeriodCriteria)(globalSearchState === null || globalSearchState === void 0 ? void 0 : globalSearchState.travelDates) });
    }
    return criteriaInput;
}
exports.mapGlobalSearchStateToSearchControlCriteriaInput = mapGlobalSearchStateToSearchControlCriteriaInput;
//# sourceMappingURL=GSS.mappers.js.map